import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { CostoFotogrametriaResponse } from "../../response/costos/CostoFotogrametriaResponse";
import { CostoFotogrametriaPayload } from "../api/payload/costos/CostoFotogrametriaPayload";
import { ServiceSaveBase } from "../base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoFotogrametriaListService, toCostoFotogrametriaResponse } from "./CostoFotogrametriaListService";

/** Edición del valor de una variable de VISTA; el resultado reemplaza la fila del listado. */
export class CostoFotogrametriaSaveService extends ServiceSaveBase<CostoFotogrametriaResponse, CostoFotogrametriaPayload> {
  static readonly instance = new CostoFotogrametriaSaveService();
  private constructor() { super(); }

  protected readonly cache = CostoFotogrametriaListService.instance;

  /** gRPC-Web (`GuardarFotogrametria`): solo cambia el valor; el `id` es obligatorio. */
  protected async sendSave(p: CostoFotogrametriaPayload): Promise<CostoFotogrametriaResponse> {
    const t = await grpcCall(() => grpcClient(CostosPlataformaService).guardarFotogrametria({
      id: p.id ?? "",
      valor: BigInt(p.valor),
    }));
    return toCostoFotogrametriaResponse(t);
  }
}
